import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UserRole, UserRoleCreate, UserRoleFilter } from '../data/userRole';

export function createUserRoleService(client: AxiosInstance) {
  return createCrudService<UserRole, UserRoleCreate, UserRoleFilter>(client, '/UserRole', 'userRoleId');
}

export type UserRoleService = CrudService<UserRole, UserRoleCreate, UserRoleFilter>;
